import { Injectable } from '@angular/core';
import { NzTreeBaseService } from 'ant-reset-private/core';

@Injectable()
export class NzTreeService extends NzTreeBaseService {}
